import { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Loader2 } from "lucide-react";

interface RecruiterProtectedRouteProps {
  children: ReactNode;
}

export function RecruiterProtectedRoute({ children }: RecruiterProtectedRouteProps) {
  const { user, userRole, userRoleData, isLoading } = useAuth();

  // Wait for both auth and role to load before making decisions
  if (isLoading || (user && userRole === null)) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/auth" replace />;
  }

  // Allow recruiters and admins (for viewAs mode)
  const isRecruiter = userRole === "admin" || 
    (userRole === "employee" && userRoleData?.employee_type === "recrutador");
  
  if (!isRecruiter) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
